export const cloudSubscriptionsRouteLinks = {
    root: "/cloud-subscriptions",
    subscription: (cloudSubscriptionId: string) => ({
        root: `/cloud-subscriptions/${cloudSubscriptionId}`,
    })
};